import { Action, action } from 'easy-peasy'

interface State {
  user_id: string
  course_id: string
  secret_id: string
  membership_roles: string[]
  staff: boolean
}
interface Actions {
  setUser: Action<this, object>
}
// eslint-disable-next-line
interface Thunks {}

export interface IUserModel extends State, Actions, Thunks {}

export const UserModel: IUserModel = {
  user_id: '',
  course_id: '',
  secret_id: '',
  membership_roles: [],
  staff: false,

  // Actions
  setUser: action((state, payload: IUserModel) => {
    Object.assign(state, payload)
  })
}
